import { gql } from "urql";
export const GlobalSearchQuery = gql `
    query GlobalSearch($query: String!) {
        globalSearch {
            search(query: $query) {
                users {
                    id
                    name
                    type
                    description
                    imageUrl
                }
                patients {
                    id
                    name
                    type
                    description
                    imageUrl
                }
                organizations {
                    id
                    name
                    type
                    description
                    imageUrl
                }
            }
        }
    }
`;
